export class FarmersRequestModel{
    id:number
    name:string;
    code:string;
    supplier_category:string	
    gst_number:string	
    contact_person:string;
    street:string;
    apartment:string;
    city:string;	
    state:string;
    district:string;
    mobileNumber:string
    constructor(
        id:number,
    name:string,
    code:string,
    supplier_category:string,
    gst_number:string,
    contact_person:string,
    street:string,
    apartment:string,
    city:string,	
    state:string,
    district:string,
    mobileNumber:string
    ){
       this.apartment = apartment
       this.id= id
       this.city = city
       this.contact_person = contact_person
       this.district = district
       this.gst_number = gst_number
       this.name = name
       this.state = state
       this.supplier_category =supplier_category
       this.street = street
       this.code = code
       this.mobileNumber = mobileNumber
    }
}
export class FarmersRequestModelDto{
    data:FarmersRequestModel[]
    user:string
    constructor(
        data:FarmersRequestModel[],
        user:string
    ){
        this.data = data
        this.user = user
    }
}
